import React from 'react';
export var ActionBarContext = React.createContext('primary');
ActionBarContext.displayName = 'ActionBarContext';
export var SecondaryActionBarContext = React.createContext({
    setTopActionBarRef: function () { return null; },
});
SecondaryActionBarContext.displayName = 'SecondaryActionBarContext';
//# sourceMappingURL=ActionBarContext.js.map